var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n    Warning\r\n  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,20 L0,20 L9.9995117,0 L20,20 Z M2.4306641,18.4980469 L17.5683594,18.4980469 L9.9995117,3.3598633 L2.4306641,18.4980469 Z M10.0004883,16.7724609 C9.39346048,16.7724609 8.9013672,16.3024473 8.9013672,15.7226562 C8.9013672,15.1428651 9.39346048,14.6728515 10.0004883,14.6728515 C10.6075161,14.6728515 11.0996094,15.1428651 11.0996094,15.7226562 C11.0996094,16.3024473 10.6075161,16.7724609 10.0004883,16.7724609 Z M9.1000977,8.2265625 L10.9008789,8.2265625 L10.9008789,13.6679687 L9.1000977,13.6679687 L9.1000977,8.2265625 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ceed51fbe26cb2448a71d4ac8e66da77.svg";
export { ForwardRef as ReactComponent };